<div class="text-error-main error-wrapper">
  <ng-content></ng-content>
</div>
